import React, {Component} from "react";
import {map} from "lodash";

import visa from "../../../../Assets/images/visa_dark.svg";
import american from "../../../../Assets/images/american_express_dark.svg";

const frequency_data = [
  {key: 'Twice Weekly', value: 'twice_weekly'},
  {key: 'Weekly', value: 'weekly'},
  {key: 'Every Other Week', value: 'bi_monthly'},
  {key: 'Monthly', value: 'monthly'},
  {key: 'One-Time', value: 'once'},
]

// mapping property type
const property_type = [
  {key: 'Town House', value: 'townhouse'},
  {key: 'Detached', comment: '<.5 acres. lot', value: 'single_family_small'},
  {key: 'Detached', comment: '>.5 acres. lot - FO to assess', value: 'single_family_large'},
]

const area_clean = [
  { key: 'Front Yard', value: 'front yard'},
  { key: 'Back Yard', value: 'back yard'},
  { key: 'Right Side', value: 'right side'},
  { key: 'Left Side', value: 'left side'},
  { key: 'Dog Run', value: 'dog run'},
  { key: 'Fenced Area', value: 'fenced area'},
  { key: 'Other', value: ''},
];

const last_cleaned = [
  { key: 'Less than 2 weeks', value: 'less_than_2_weeks'},
  { key: '2 to 6 weeks', value: '1-2_months'},
  { key: 'More than 6 weeks', value: '2_months_or_more'}
]

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceOrder: {}
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // get service order
    if (Object.keys(nextProps?.serviceOrder?.data).length > 0) {
      this.setState({ serviceOrder: nextProps?.serviceOrder?.data?.results?.[0] || {} });
    }
  }

  renderConfirmation = () => {
    const {serviceOrder} = this.state;
    const {PricingCalc} = this.props;
    const PricingCalcData = PricingCalc?.data || {};
    const frequencyValue = frequency_data.filter(obj => obj.value === serviceOrder?.calculated_price?.frequency);
    const propertyValue = property_type.filter(obj => obj.value === serviceOrder?.calculated_price?.property_type);
    const areaCleanValue = area_clean.filter(obj => serviceOrder?.calculated_price?.area_to_clean?.includes(obj.value));
    const isExistPricingData = Object.keys(PricingCalcData).length > 0;

    const billing_address = serviceOrder?.billing_address
    let addressStr = billing_address?.address ? `, ${billing_address?.address}` : '';
    addressStr += billing_address?.city ? `, ${billing_address?.city}` : '';
    addressStr += billing_address?.state ? `, ${billing_address?.state}` : '';
    addressStr += billing_address?.zip_code ? `, ${billing_address?.zip_code}` : '';

    return (
      <div className="aside-bar">
        <div className="acol">
          <h2 className="mb-20">Your service confirmed!</h2>
          <h4>Billing details</h4>
          <div className={"d-block"}>
            <div className="card_img flex ai-center flex-start">
              {serviceOrder?.user_billing_info?.stripe_card_details?.brand === 'visa' ?
                <img src={visa} alt="" /> :
                <img src={american} alt="" />} &nbsp;&nbsp;
              <label className="m-0">{`${serviceOrder?.user_billing_info?.stripe_card_details?.brand} ending in ${serviceOrder?.user_billing_info?.stripe_card_details?.last4}`}</label>
            </div>
            <p className="mt-10">{addressStr}</p>
          </div>
          <hr/>
          <h4>Subscription details</h4>
          {
            isExistPricingData &&
            <div className="flex">
              <div className="flex-1">
                <p>{`${frequencyValue?.[0]?.key} service, ${areaCleanValue?.[0]?.key} ${propertyValue?.[0]?.key}  ${propertyValue?.[0]?.comment ? `(${propertyValue?.[0]?.comment})` : ''}`}</p>
                <p>{`${serviceOrder?.pet_count} ${serviceOrder?.pet_count === '1' ? 'Dog' : 'Dogs'}`}</p>
              </div>
              {isExistPricingData && <div className=""><b>${PricingCalcData?.service_base_price}</b></div>}
            </div>
          }
          <hr/>
          {
            map(PricingCalcData?.cleaning_areas?.items, (item, i) => {
              if (i !== 0) {
                return (
                  <div className="flex">
                    <div className="flex-1" key={`cleaning_areas${i}`}>
                      <p>{item.area ? item.area : 'Other'}</p>
                    </div>
                    <div className=""><b>+${item.price}</b></div>
                  </div>
                )
              }
            })
          }
          {map(PricingCalcData && PricingCalcData.recurring_add_ons && PricingCalcData.recurring_add_ons.recurring_addon_items, (item, i) => {
            if (item.type === 'add_on') {
              return (
                <div className="flex" key={`recurring_add_ons${i}`}>
                  <div className="flex-1">
                    <p>{item.name}</p>
                  </div>
                  <div className=""><b>+${item.price}</b></div>
                </div>
              )
            }
          })
          }
          <div className="highlight">
            <div className="flex">
              <div className="flex-1">
                {serviceOrder?.calculated_price?.frequency === "once" ? <h4 className="m-0">Price for a single visit</h4> :
                  <h4 className="m-0">Price per {frequencyValue?.[0]?.key?.toLowerCase()} visit</h4> }
                <p>{`Billed ${serviceOrder?.calculated_price?.frequency === 'once' ? 'Just Once' : 'Monthly'}`}</p>
              </div>
              {isExistPricingData && <div className="pricing"><b>+${PricingCalcData?.total_price_per_service}</b></div>}
            </div>
          </div>
          <div className="flex mt-30">
            <div className="flex-1">
              <h4 className="mb-0">One-time charge(s)</h4>
              {PricingCalcData.cleaning_areas ? map(PricingCalcData && PricingCalcData.one_time_charges && PricingCalcData.one_time_charges.one_time_items, (item, i) => {
                if (item.type === 'last_clean') {
                  const lastCleanedValue = last_cleaned.filter(obj => obj.value === item.name);
                  return <p key={`cleaning${i}`}>{lastCleanedValue?.[0]?.key} since last clean</p>
                }
                return <p key={`cleaning${i}`}>{item.name}</p>
              }) : ''
              }
            </div>
            {isExistPricingData && <div className=""><b>+${PricingCalcData?.one_time_charges?.total_one_time_charge}</b></div>}
          </div>
          <div className="wlight">
            <div className="flex ai-center">
              <div className="flex-1">
                <h4 className="m-0">Total for first visit</h4>
              </div>
              {isExistPricingData && <div className="pricing"><b>+${PricingCalcData?.total_price_for_first_visit}</b></div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  render() {
    return this.renderConfirmation();
  }
}

export default SideBar;